import { render, staticRenderFns } from "./DialogPreviousAttachment.vue?vue&type=template&id=6cee8c49&scoped=true&"
import script from "./DialogPreviousAttachment.vue?vue&type=script&lang=js&"
export * from "./DialogPreviousAttachment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cee8c49",
  null
  
)

export default component.exports